<template>
  <div class="modal" tabindex="-1">
    <!-- Content -->
    <div class="modal-content">
      <!-- Content -->
      <div class="row" style="padding: 0; margin: 0">
        <v-layout row="wrap" align-center px-4 py-3 mb-5>
          <v-flex
            shrink
            class="title-text"
            style="color: #a6cc39; font-size: 27px !important"
            >{{ $t(modalTitle) }}</v-flex
          >
          <v-spacer />
          <v-flex shrink>
            <img
              alt
              src="@/assets/imgs/close.jpg"
              style="width: 16px; height: 16px; cursor: pointer"
              @click="close"
            />
          </v-flex>
        </v-layout>
        <!-- 2 Tabs Content -->

        <template>
          <div class="col-lg-12 clear mt-1 pr-1 pl-2">
            <div class="row">
              <!-- General Information Tab -->
              <div
                class="col-lg-6 tab-item"
                :class="{ active: companyActiveTab === 'general' }"
                @click="companyActiveTab = 'general'"
              >
                {{ $t("generalinformation") }}
              </div>

              <!-- Sale Information Tab -->
              <div
                class="col-lg-6 tab-item"
                :class="{ active: companyActiveTab === 'sale' }"
                @click="companyActiveTab = 'sale'"
              >
                {{ $t("saleinformation") }}
              </div>
            </div>

            <!-- Tab Content -->
            <div class="tab-content">
              <div v-if="companyActiveTab === 'general'">
                <div
                  class="col-lg-12 "
                  style="border-bottom:2px solid #A6CC39;color:#D6C583;padding:0px;"
                >
                  <h5 class="title-textgeneralandsale" style="color: #a6cc39">
                    {{ $t("companyingormation") }}
                  </h5>
                </div>
                <v-row>
                  <!-- Title -->
                  <div class="col-lg-4 form-group clear mt-4 pr-5 pl-2">
                    <label for="inputCompany" class="b-text">
                      {{ $t("companyname") }}
                      <span style="color: red">*</span>
                    </label>
                    <input
                      type="text"
                      ref="companyName"
                      class="form-control"
                      id="inputCompany"
                      :placeholder="localeCompanyName()"
                      v-model="companyName"
                      :style="[namecheck ? { border: ' 1px solid red' } : {}]"
                      style="border: 1px solid #707070; border-radius: 10px"
                    />
                    <div v-if="namecheck" style="color: red" class="text">
                      {{ $t("companyname") }} is required
                    </div>
                    <div
                      v-if="checkalphabet2 == true"
                      style="color: red"
                      class="text"
                    >
                      Please fill in Alphabet.
                    </div>
                  </div>

                  <div
                    class="col-lg-4 form-group clear mt-4 pr-5 pl-2"
                    v-if="modalTitle == 'newcompany'"
                  >
                    <label for="inputCompany" class="b-text">
                      {{ $t("abbre") }}
                      <span style="color: red">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      @keydown="checkAlphabet"
                      :placeholder="localeAbbreviation()"
                      v-model="abbr"
                      :style="[abbrevCheck ? { border: ' 1px solid red' } : {}]"
                      style="border: 1px solid #707070; border-radius: 10px"
                    />
                    <div
                      v-if="checkalphabet == true"
                      style="color: red"
                      class="text"
                    >
                      Please fill in Alphabet or Number.
                    </div>
                    <div v-if="abbrevCheck" style="color: red" class="text">
                      {{ $t("abbre") }} is required
                    </div>
                  </div>
                  <div
                    class="col-lg-4 form-group clear mt-4 pr-5 pl-2"
                    v-if="modalTitle == 'editcompany'"
                  >
                    <label for="inputCompany" class="b-text">
                      {{ $t("abbre") }}
                      <span style="color: red">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      :placeholder="localeAbbreviation()"
                      @keydown="checkAlphabet"
                      v-model="abbr"
                      :style="[abbrevCheck ? { border: ' 1px solid red' } : {}]"
                      style="border: 1px solid #707070; border-radius: 10px"
                    />
                    <div
                      v-if="checkalphabet == true"
                      style="color: red"
                      class="text"
                    >
                      Please fill in Alphabet or Number.
                    </div>
                    <div v-if="abbrevCheck" style="color: red" class="text">
                      {{ $t("abbre") }} is required.
                    </div>
                  </div>
                  <div class="col-lg-4 form-group clear mt-4 pr-5 pl-2">
                    <label class="b-text" style="margin-top: 10px">
                      {{ $t("contactname") }}
                      <span style="color: red">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="inputcontactname"
                      :placeholder="localeContactName()"
                      :style="[
                        contactnamecheck ? { border: ' 1px solid red' } : {}
                      ]"
                      v-model="contactName"
                      style="border: 1px solid #707070; border-radius: 10px"
                    />
                    <div
                      v-if="contactnamecheck"
                      style="color: red"
                      class="text"
                    >
                      {{ $t("contactname") }} is required
                    </div>
                  </div>
                </v-row>
                <v-row>
                  <div class="col-lg-4 form-group clear mt-4 pr-5 pl-2">
                    <label for="inputEmail" class="b-text">
                      {{ $t("email") }}
                      <span style="color: red">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="inputEmail"
                      :placeholder="localeEmail()"
                      :style="[mailcheck ? { border: ' 1px solid red' } : {}]"
                      v-model="email"
                      style="border: 1px solid #707070; border-radius: 10px"
                    />
                    <div v-if="mailcheck" style="color: red" class="text">
                      Please enter correct {{ $t("email") }}
                    </div>
                  </div>
                  <div class="col-lg-4 form-group clear mt-4 pr-5 pl-2">
                    <label for="inputTelephone" class="b-text">
                      {{ $t("telephoneno") }}
                      <span style="color: red">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="inputTelephone"
                      :placeholder="localeTelephone()"
                      @keydown="isNumber($event)"
                      v-model="telephoneNumber"
                      :style="[phonecheck ? { border: ' 1px solid red' } : {}]"
                      v-mask="'###########'"
                      style="border: 1px solid #707070; border-radius: 10px"
                    />
                    <div
                      v-if="checknumber == true"
                      style="color: red"
                      class="text"
                    >
                      Please fill in Number.
                    </div>
                    <div v-if="phonecheck" style="color: red" class="text">
                      {{ $t("telephoneno") }} is required.
                    </div>
                    <div v-if="phonenolength" style="color: red" class="text">
                      {{ $t("enterphno") }}
                    </div>
                  </div>
                  <div class="col-lg-4 form-group clear mt-4 pr-5 pl-2">
                    <label for="inputCountry" class="b-text">
                      {{ $t("country") }}
                      <span style="color: red">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="inputCountry"
                      :placeholder="localeCountry()"
                      v-model="countryName"
                      :style="[
                        countrycheck ? { border: ' 1px solid red' } : {}
                      ]"
                      style="border: 1px solid #707070; border-radius: 10px"
                    />
                    <div v-if="countrycheck" style="color: red" class="text">
                      {{ $t("country") }} is required
                    </div>
                  </div>
                </v-row>
                <v-row>
                  <div class="col-lg-4 form-group clear mt-4 pr-5 pl-2">
                    <label for="inputCity" class="b-text">
                      {{ $t("city") }}
                      <span style="color: red">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="inputCity"
                      :placeholder="localeCity()"
                      :style="[citycheck ? { border: ' 1px solid red' } : {}]"
                      v-model="cityName"
                      style="border: 1px solid #707070; border-radius: 10px"
                    />
                    <div v-if="citycheck" style="color: red" class="text">
                      {{ $t("city") }} is required
                    </div>
                  </div>
                  <!-- Detail -->
                  <div class="col-lg-4 form-group clear mt-4 pr-5 pl-2">
                    <label for="inputAddress" class="b-text">
                      {{ $t("address") }}
                      <span style="color: red">*</span>
                    </label>
                    <textarea
                      type="text"
                      class="form-control"
                      id="inputAddress"
                      :placeholder="localeAddress()"
                      rows="4"
                      v-model="address"
                      :style="[
                        addresscheck ? { border: ' 1px solid red' } : {}
                      ]"
                      style="border: 1px solid #707070; border-radius: 10px"
                    ></textarea>
                    <div v-if="addresscheck" style="color: red" class="text">
                      {{ $t("address") }} is required
                    </div>
                  </div>
                  <!-- Business Type -->

                  <div class="col-lg-4 form-group clear mt-4 pr-5 pl-2">
                    <label for="inputpackagename" class="b-text">
                      {{ $t("businesstype") }}
                      <span style="color: red">*</span>
                    </label>
                    <v-select
                      dense
                      v-model="businessTypeID"
                      outlined
                      style="border-radius:10px!important;"
                      :items="filteredNames"
                      @change="handleOptionChange(businessTypeID)"
                      item-text="thai_Name"
                      item-value="id"
                    >
                      <template v-slot:prepend-item>
                        <v-list-item>
                          <v-list-item-content>
                            <v-text-field
                              v-model="search"
                              :placeholder="$t('search')"
                              @input="searchInLists"
                              autocomplete="off"
                              hide-details
                              class="searchinlist"
                              append-icon="mdi-magnify"
                            ></v-text-field>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-select>
                    <div v-if="businesscheck" style="color: red" class="text">
                      {{ $t("businesstype") }} is required
                    </div>
                  </div>
                </v-row>
                <v-row>
                  <div
                    class="col-lg-4 form-group clear mt-0 pr-5 pl-2"
                    v-show="businessTypeID === 30"
                  >
                    <label for="inputactiveemployees" class="b-text">
                      {{ $t("otheroptionsfield") }}
                      <span style="color: red">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="inputcontactname"
                      :placeholder="otheroptionstype()"
                      :style="[
                        otherbusinesscheck ? { border: ' 1px solid red' } : {}
                      ]"
                      v-model="businessTypeOther"
                      style="border: 1px solid #707070; border-radius: 10px"
                    />
                    <div
                      v-if="otherbusinesscheck"
                      style="color: red"
                      class="text"
                    >
                      {{ $t("businesstype") }} is required
                    </div>
                  </div>
                  <div class="col-lg-8 form-group clear mt -6 pr-5 pl-2">
                    <label for="inputNote" class="b-text">
                      {{ $t("note") }}
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="inputNote"
                      :placeholder="localeNote()"
                      rows="4"
                      v-model="note"
                      style="border: 1px solid #707070; border-radius: 10px"
                    />
                  </div>
                </v-row>
                <!-- Date details -->
                <v-row>
                  <v-col cols="12" sm="6" md="4" lg="4" xl="4">
                    <label class="b-text" style="margin-top: 3px">
                      {{ $t("startdate") }}
                      <span style="color: red">*</span>
                    </label>
                    <div class="d-flex from-date">
                      <v-menu
                        v-model="start_menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :style="[
                              start_dateCheck ? { border: '1px solid red' } : {}
                            ]"
                            v-model="start_date"
                            append-icon="mdi-calendar"
                            outlined
                            dense
                            readonly
                            hide-details
                            placeholder="-- Please select --"
                            v-bind="attrs"
                            v-on="on"
                            style="border-radius: 10px;"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="start_date"
                          @input="startDateDis()"
                        ></v-date-picker>
                      </v-menu>
                    </div>
                    <div v-if="start_dateCheck" style="color: red" class="text">
                      {{ $t("startdate") }} is required
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="4" xl="4">
                    <label class="b-text" style="margin-top: 3px">
                      {{ $t("reminderdate") }}
                      <span style="color: red">*</span>
                    </label>
                    <div class="d-flex to-date">
                      <v-menu
                        v-model="reminder_menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            class="ml-0"
                            :style="[
                              reminder_dateCheck
                                ? { border: ' 1px solid red' }
                                : {}
                            ]"
                            v-on="on"
                            v-model="reminder_date"
                            append-icon="mdi-calendar"
                            outlined
                            dense
                            readonly
                            placeholder="-- Please select --"
                            v-bind="attrs"
                            hide-details=""
                            style="border-radius: 10px"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="reminder_date"
                          @input="endDateDis(), (reminder_menu = false)"
                          :allowed-dates="allowedDatesEnd"
                        ></v-date-picker>
                      </v-menu>
                    </div>
                    <div
                      v-if="reminder_dateCheck"
                      style="color: red"
                      class="text"
                    >
                      {{ $t("reminderdate") }} is required
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="4" xl="4">
                    <label class="b-text" style="margin-top: 3px">
                      {{ $t("expirydate") }}
                      <span style="color: red">*</span>
                    </label>
                    <div class="d-flex to-date">
                      <v-menu
                        v-model="expiry_menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            class="ml-0"
                            :style="[
                              expiry_dateCheck
                                ? { border: ' 1px solid red' }
                                : {}
                            ]"
                            v-on="on"
                            v-model="expiry_date"
                            append-icon="mdi-calendar"
                            outlined
                            dense
                            readonly
                            placeholder="-- Please select --"
                            v-bind="attrs"
                            hide-details
                            style="border-radius: 10px"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="expiry_date"
                          @input="expiredDateDis(), (expiry_menu = false)"
                          :allowed-dates="allowedDatesExpiry"
                        ></v-date-picker>
                      </v-menu>
                    </div>
                    <div
                      v-if="expiry_dateCheck"
                      style="color: red"
                      class="text"
                    >
                      {{ $t("expirydate") }} is required
                    </div>
                  </v-col>
                </v-row>
                <!-- User Information -->
                <div
                  class="col-lg-12 form-group clear mt-2"
                  style="border-bottom:2px solid #A6CC39;color:#004A17;padding:0px;"
                >
                  <h5 class="title-text" style="color: #a6cc39">
                    {{ $t("logincredentials") }}
                  </h5>
                </div>
                <v-container :fluid="true" grid-list-xl>
                  <v-layout row wrap style="margin-left: -20px">
                    <v-flex xs12 sm6>
                      <p>
                        {{ $t("username") }}
                        <span style="color: red">*</span>
                      </p>
                      <v-text-field
                        single
                        outlined
                        dense
                        id="inputUserID"
                        v-model="userName"
                        hide-details
                        v-if="modalTitle == 'newcompany'"
                        style="border-radius: 10px"
                        :style="[
                          useridcheck ? { border: ' 1px solid red' } : {}
                        ]"
                      ></v-text-field>
                      <v-text-field
                        single
                        outlined
                        dense
                        id="inputUserID"
                        v-model="userName"
                        v-if="modalTitle == 'editcompany'"
                        style="border-radius: 10px"
                        hide-details
                        :style="[
                          useridcheck ? { border: ' 1px solid red' } : {}
                        ]"
                      ></v-text-field>
                      <div v-if="useridcheck" style="color: red" class="text">
                        Username is Required
                      </div>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <p>
                        {{ $t("password") }}
                        <span style="color: red">*</span>
                      </p>
                      <v-text-field
                        single
                        outlined
                        dense
                        id="inputPassword"
                        v-model="password"
                        hide-details
                        v-if="modalTitle == 'newcompany'"
                        :append-icon="clkeye ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="clkeye ? 'text' : 'password'"
                        @click:append="clkeye = !clkeye"
                        style="border-radius: 10px"
                        :style="[
                          passwordcheck ? { border: ' 1px solid red' } : {}
                        ]"
                      ></v-text-field>

                      <v-text-field
                        single
                        outlined
                        dense
                        id="inputPassword"
                        v-model="password2"
                        hide-details
                        v-if="modalTitle == 'editcompany'"
                        :append-icon="editeye ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="editeye ? 'text' : 'text'"
                        @click:append="editeye = !editeye"
                        style="border-radius: 10px"
                        :style="[
                          passwordcheck ? { border: ' 1px solid red' } : {}
                        ]"
                        placeholder="******"
                      ></v-text-field>
                      <div v-if="passwordcheck" style="color: red" class="text">
                        Password is required
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap style="margin-left: -20px">
                    <v-flex xs12 sm3>
                      <p>
                        {{ $t("adminstatus") }}
                      </p>
                      <v-row class="ma-1">
                        <v-col
                          class="tab2ColHeight pa-0 mt-1"
                          cols="4"
                          sm="2"
                          md="2"
                          lg="2"
                          xl="2"
                        >
                          <v-switch
                            v-model="lock"
                            inset
                            :label="lock == true ? 'On' : 'Off'"
                            class="mt-1 onoffbtn"
                          >
                            <template v-slot:label>
                              <label
                                v-if="lock == true"
                                class="v-label theme--light"
                                style="left: -75px;right: auto;top:-12px; position: absolute !important; font-size: 15px; text-transform:uppercase;"
                                >On</label
                              >
                              <label
                                class="v-label theme--light"
                                v-if="lock == false"
                                style="left: -45px;right: auto;top:-12px; position: absolute !important; font-size: 15px; text-transform:uppercase;"
                                >Off</label
                              >
                            </template>
                          </v-switch>
                        </v-col>
                      </v-row>
                    </v-flex>
                    <v-flex xs12 sm3>
                      <p>
                        {{ $t("company_status") }}
                      </p>
                      <v-row class="ma-1">
                        <v-col
                          class="tab2ColHeight pa-0 mt-1"
                          cols="4"
                          sm="2"
                          md="2"
                          lg="2"
                          xl="2"
                        >
                          <v-switch
                            v-model="status"
                            inset
                            :label="status == true ? 'On' : 'Off'"
                            class="mt-1 onoffbtn"
                          >
                            <template v-slot:label>
                              <label
                                v-if="status == true"
                                class="v-label theme--light"
                                style="left: -75px;right: auto;top:-12px; position: absolute !important; font-size: 15px; text-transform:uppercase;"
                                >On</label
                              >
                              <label
                                class="v-label theme--light"
                                v-if="status == false"
                                style="left: -45px;right: auto;top:-12px; position: absolute !important; font-size: 15px; text-transform:uppercase;"
                                >Off</label
                              >
                            </template>
                          </v-switch>
                        </v-col>
                      </v-row>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <p>
                        {{ $t("sendnoti") }}
                      </p>
                      <v-row>
                        <v-col cols="12" class="mt-0">
                          <SelectEmailLanguageBtn
                            :checked_mail="emailcheck"
                            :language="selectedEmailLang"
                            @update-text="UpdateEmailLanguage"
                            @update-flag="UpdateEmailFlag"
                          />
                        </v-col>
                      </v-row>
                    </v-flex>
                  </v-layout>
                </v-container>
                <v-layout row="wrap" align-center py-3>
                  <v-spacer />
                  <v-flex xs6 md3 px-3>
                    <div style="max-width: 240px">
                      <v-btn
                        block
                        class="ma-2"
                        @click="close"
                        style="color: #707070; text-transform: none"
                        text
                        >{{ $t("cancel") }}</v-btn
                      >
                    </div>
                  </v-flex>
                  <v-flex xs6 md3 px-3 v-if="modalTitle == 'newcompany'">
                    <div style="max-width: 240px">
                      <v-btn
                        block
                        depressed
                        @click="companyActiveTab = 'sale'"
                        color="#6CC8A0"
                        style="color: white"
                        >{{ $t("next") }}</v-btn
                      >
                    </div>
                  </v-flex>
                  <v-flex xs6 md3 px-3 v-if="modalTitle == 'editcompany'">
                    <div style="max-width: 240px">
                      <v-btn
                        block
                        depressed
                        @click="companyActiveTab = 'sale'"
                        color="#6CC8A0"
                        style="color: white"
                        >{{ $t("next") }}</v-btn
                      >
                      <!-- <v-btn
              block
              depressed
              @click="Edit"
              color="#6CC8A0"
              style="color: white"
              >{{ $t("update") }}</v-btn
            > -->
                    </div>
                  </v-flex>
                </v-layout>

                <v-row> </v-row>
              </div>
              <div v-if="companyActiveTab === 'sale'">
                <div
                  class="col-lg-8"
                  style="border-bottom:2px solid #A6CC39;color:#D6C583;padding:0px 8px;"
                >
                  <h5 class="title-textgeneralandsale" style="color: #a6cc39">
                    {{ $t("pricingplan") }}
                  </h5>
                </div>

                <div>
                  <v-row>
                    <div class="col-lg-4 form-group clear mt-0 pr-3 pl-3">
                      <label for="inputpackagename" class="b-text">
                        {{ $t("packagename") }}
                        <span style="color: red">*</span>
                      </label>
                      <select
                        v-model="packageName"
                        :style="[
                          packagenamecheck ? { border: ' 1px solid red' } : {}
                        ]"
                        style="border: 1px solid #707070; border-radius: 10px"
                      >
                        <option
                          v-for="item in packagenameList"
                          :value="item.pkgID"
                          v-bind:key="item.pkgID"
                        >
                          {{ item.pkgName }}
                        </option>
                      </select>
                      <span>
                        <v-icon
                          style="
                                  height: 40px;
                                  margin: 0 0 0 -1.8rem;
                                  vertical-align: top;
                                  border-radius: 5.5rem;
                                  border: none;
                                "
                          >mdi-chevron-down</v-icon
                        >
                      </span>
                      <div
                        v-if="packagenamecheck"
                        style="color: red"
                        class="text"
                      >
                        {{ $t("packagename") }} is required
                      </div>
                    </div>

                    <div class="col-lg-4 form-group clear mt-0 pr-3 pl-3">
                      <label for="inputactiveemployees" class="b-text">
                        {{ $t("activeemployees") }}
                        <span style="color: red">*</span>
                      </label>
                      <select
                        v-model="activeEmployee"
                        :style="[
                          activeemployeecheck
                            ? { border: ' 1px solid red' }
                            : {}
                        ]"
                        style="border: 1px solid #707070; border-radius: 10px"
                      >
                        <option
                          v-for="item in activeemployeeList"
                          :value="item.activeEmpId"
                          v-bind:key="item.activeEmpId"
                        >
                          {{ item.activeEmp }}
                        </option>
                      </select>
                      <span>
                        <v-icon
                          style="
                                height: 40px;
                                margin: 0 0 0 -1.8rem;
                                vertical-align: top;
                                border-radius: 5.5rem;
                                border: none;
                              "
                          >mdi-chevron-down</v-icon
                        >
                      </span>
                      <div
                        v-if="activeemployeecheck"
                        style="color: red"
                        class="text"
                      >
                        {{ $t("activeemployees") }} is required
                      </div>
                    </div>
                    <div class="col-lg-4 form-group clear mt-0 pr-3 pl-3">
                      <label for="inputnumberoffiles" class="b-text">
                        {{ $t("numberoffilesupload") }}
                        <span style="color: red">*</span>
                      </label>
                      <select
                        v-model="numberOfFile"
                        :style="[
                          numberoffilesuploadcheck
                            ? { border: ' 1px solid red' }
                            : {}
                        ]"
                        style="border: 1px solid #707070; border-radius: 10px"
                      >
                        <option
                          v-for="item in numberoffileList"
                          :value="item.numberOfFilesId"
                          v-bind:key="item.numberOfFilesId"
                        >
                          {{ item.numberOfFiles }}
                        </option>
                      </select>
                      <span>
                        <v-icon
                          style="
                              height: 40px;
                              margin: 0 0 0 -1.8rem;
                              vertical-align: top;
                              border-radius: 5.5rem;
                              border: none;
                            "
                          >mdi-chevron-down</v-icon
                        >
                      </span>
                      <div
                        v-if="numberoffilesuploadcheck"
                        style="color: red"
                        class="text"
                      >
                        {{ $t("numberoffilesupload") }} is required
                      </div>
                    </div>
                  </v-row>
                  <v-row>
                    <div class="col-lg-4 form-group clear mt-0 pr-3 pl-3">
                      <label for="salenamename" class="b-text">
                        {{ $t("salename") }}
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        id="salenamename"
                        :placeholder="localeSalename()"
                        :style="[
                          salenamecheck ? { border: ' 1px solid red' } : {}
                        ]"
                        v-model="saleName"
                        style="border: 1px solid #707070; border-radius: 10px"
                      />
                      <!-- <div v-if="salenamecheck" style="color: red" class="text">
                            {{ $t("salename") }} is required
                          </div> -->
                    </div>

                    <div class="col-lg-4 form-group clear mt-0 pr-3 pl-3">
                      <label for="inputpackagename" class="b-text">
                        {{ $t("sellingprice") }}
                      </label>
                      <input
                        type="number"
                        class="form-control"
                        id="inputpackagename"
                        :placeholder="localeSellingprice()"
                        :style="[
                          sellingpricecheck ? { border: ' 1px solid red' } : {}
                        ]"
                        v-model="sellingPrice"
                        style="border: 1px solid #707070; border-radius: 10px"
                        step="0.01"
                      />
                      <!-- <div v-if="sellingpricecheck" style="color: red" class="text">
                                    {{ $t("sellingprice") }} is required
                                </div> -->
                    </div>
                    <div class="col-lg-4 form-group clear mt-0 pr-3 pl-3">
                      <label for="paymentstatusID" class="b-text">
                        {{ $t("paymentstatus") }}
                      </label>
                      <select
                        v-model="paymentStatus"
                        :style="[
                          paymentstatuscheck ? { border: ' 1px solid red' } : {}
                        ]"
                        style="border: 1px solid #707070; border-radius: 10px"
                      >
                        <option
                          v-for="item in paymentstatustypeList"
                          :value="item.paymentId"
                          v-bind:key="item.paymentId"
                        >
                          {{ item.paymentStatus }}
                        </option>
                      </select>
                      <span>
                        <v-icon
                          style="
                                  height: 40px;
                                  margin: 0 0 0 -1.8rem;
                                  vertical-align: top;
                                  border-radius: 5.5rem;
                                  border: none;
                                "
                          >mdi-chevron-down</v-icon
                        >
                      </span>
                      <!-- <div v-if="paymentstatuscheck" style="color: red" class="text">
                                    {{ $t("paymentstatus") }} is required
                                </div> -->
                    </div>
                  </v-row>
                  <v-row>
                    <div class="col-lg-4 form-group clear mt-0 pr-3 pl-3">
                      <label for="inputpackagename" class="b-text">
                        {{ $t("paymentdate") }}
                        <!-- <span style="color: red">*</span> -->
                      </label>
                      <v-menu
                        v-model="frommenusale"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="startdatesale"
                            prepend-inner-icon="mdi-calendar-blank-outline"
                            outlined
                            dense
                            readonly
                            v-bind="attrs"
                            placeholder="yyyy/mm/dd"
                            hide-details
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="startdatesale"
                          @change="StartViewDate(), (frommenusale = false)"
                        ></v-date-picker>
                      </v-menu>
                      <!-- <div v-if="paymentdatecheck" style="color: red" class="text">
                                    {{ $t("paymentdate") }} is required
                                </div> -->
                    </div>

                    <div class="col-lg-4 form-group clear mt-0 pr-3 pl-3">
                      <label for="purchasePeriod" class="b-text">
                        {{ $t("purchaseperiod") }}
                        <!-- <span style="color: red">*</span> -->
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        id="purchasePeriods"
                        :placeholder="localePurchaseperiod()"
                        :style="[
                          purchaseperiodcheck
                            ? { border: ' 1px solid red' }
                            : {}
                        ]"
                        v-model="purchasePeriod"
                        style="border: 1px solid #707070; border-radius: 10px"
                      />
                      <!-- <div v-if="purchaseperiodcheck" style="color: red" class="text">
                                    {{ $t("purchaseperiod") }} is required
                                </div> -->
                    </div>
                  </v-row>
                  <div
                    class="col-lg-8"
                    style="border-bottom:2px solid #A6CC39;color:#D6C583;padding:0px 8px;"
                  >
                    <h5 class="title-text" style="color: #a6cc39">
                      {{ $t("additionalfunctions") }}
                    </h5>
                  </div>
                  <v-row class="align-center mt-4" no-gutters>
                    <!-- Training RoadMap -->
                    <v-col
                      cols="12"
                      sm="6"
                      md="3"
                      lg="3"
                      class="form-group clear mt-4 pr-5 pl-2"
                    >
                      <label class="b-text" style="margin-top: 0px">
                        <v-icon></v-icon>
                        {{ $t("trainingroadmap") }}
                      </label>
                      <div>
                        <v-checkbox
                          v-model="isocheck"
                          label="Access"
                          color="success"
                          class="mt-1 ml-2"
                          hide-details
                        />
                      </div>
                    </v-col>

                    <!-- Course Status -->
                    <v-col
                      cols="12"
                      sm="6"
                      md="3"
                      lg="3"
                      class="form-group clear mt-4 pr-5 pl-2"
                    >
                      <p>{{ $t("coursestatus") }}</p>
                      <v-switch
                        v-model="courseStatus"
                        inset
                        class="mt-1 onoffbtn"
                      >
                        <template v-slot:label>
                          <label
                            v-if="courseStatus"
                            class="v-label theme--light"
                            style="left:-75px; right:auto; top:-12px; position:absolute !important; font-size:15px; text-transform:uppercase;"
                          >
                            On
                          </label>
                          <label
                            v-else
                            class="v-label theme--light"
                            style="left:-45px; right:auto; top:-12px; position:absolute !important; font-size:15px; text-transform:uppercase;"
                          >
                            Off
                          </label>
                        </template>
                      </v-switch>
                    </v-col>

                    <!-- Subjective Test -->
                    <v-col
                      cols="12"
                      sm="6"
                      md="3"
                      lg="3"
                      class="form-group clear mt-4 pr-5 pl-2"
                    >
                      <p>{{ $t("SubjectiveTest") }}</p>
                      <v-switch
                        v-model="subjectiveTest"
                        inset
                        class="mt-1 onoffbtn"
                      >
                        <template v-slot:label>
                          <label
                            v-if="subjectiveTest"
                            class="v-label theme--light"
                            style="pointer-events:none; left:-75px; right:auto; top:-12px; position:absolute !important; font-size:15px; text-transform:uppercase;"
                          >
                            On
                          </label>
                          <label
                            v-else
                            class="v-label theme--light"
                            style="pointer-events:none; left:-45px; right:auto; top:-12px; position:absolute !important; font-size:15px; text-transform:uppercase;"
                          >
                            Off
                          </label>
                        </template>
                      </v-switch>
                    </v-col>

                    <!-- AI Answer Checking -->
                    <v-col
                      cols="12"
                      sm="6"
                      md="3"
                      lg="3"
                      class="form-group clear mt-4 pr-5 pl-2"
                    >
                      <p>{{ $t("AnswerChecking") }}</p>
                      <v-switch
                        v-model="aiAnswerChecking"
                        inset
                        class="mt-1 onoffbtn"
                      >
                        <template v-slot:label>
                          <label
                            v-if="aiAnswerChecking"
                            class="v-label theme--light"
                            style="pointer-events:none; left:-75px; right:auto; top:-12px; position:absolute !important; font-size:15px; text-transform:uppercase;"
                          >
                            On
                          </label>
                          <label
                            v-else
                            class="v-label theme--light"
                            style="pointer-events:none; left:-45px; right:auto; top:-12px; position:absolute !important; font-size:15px; text-transform:uppercase;"
                          >
                            Off
                          </label>
                        </template>
                      </v-switch>
                    </v-col>
                  </v-row>

                  <v-row align="center" py-3>
                    <!-- First Column (With Space or Content) -->
                    <v-col cols="6" class="px-3">
                      <!-- Empty or other content can go here -->
                    </v-col>

                    <!-- Second Column (Three Equal-Sized Buttons in a Row) -->
                    <v-col cols="6" class="d-flex justify-end">
                      <div class="flex-grow-1 mx-2">
                        <v-btn
                          block
                          depressed
                          color="#FF0000"
                          style="color: white"
                          @click="companyActiveTab = 'general'"
                        >
                          {{ $t("previous") }}
                        </v-btn>
                      </div>

                      <div class="flex-grow-1 mx-2">
                        <v-btn
                          block
                          @click="close"
                          style="color: #707070; text-transform: none"
                          text
                        >
                          {{ $t("cancel") }}
                        </v-btn>
                      </div>

                      <div
                        v-if="modalTitle == 'newcompany'"
                        class="flex-grow-1 mx-2"
                      >
                        <v-btn
                          block
                          depressed
                          @click="Add"
                          color="#6CC8A0"
                          style="color: white"
                        >
                          {{ $t("save") }}
                        </v-btn>
                      </div>

                      <div
                        v-if="modalTitle == 'editcompany'"
                        class="flex-grow-1 mx-2"
                      >
                        <v-btn
                          block
                          depressed
                          @click="Edit"
                          color="#6CC8A0"
                          style="color: white"
                        >
                          {{ $t("update") }}
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                  <div></div>
                </div>
                <div>
                  <!-- <v-row >
            <v-spacer>
            
            </v-spacer>
            <v-flex xs6 md3 px-3>
                <div style="max-width: 240px">
            <v-btn
                block
                class="ma-2"
              @click="close"
                style="color: #707070; text-transform: none"
                text
            >
                {{ $t("cancel") }}
            </v-btn>
            </div>
        </v-flex>
        <v-flex xs6 md3 px-3>
            <div style="max-width: 240px; margin-right: 10px;">
            <v-btn
                block
                depressed
                @click="AddSale"
                color="#6CC8A0"
                style="color: white"
            >
                {{ $t("save") }}
            </v-btn>
            </div>
        </v-flex>
                </v-row> -->
                </div>
                <!-- <SalesInformation v-if="activeTab === 'sale'" />-->
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <v-dialog v-model="dialog" persistent width="300">
      <v-card color="#FFF4EB" dark>
        <v-card-text class="black--text">
          Loading Please Wait...
          <v-progress-linear
            indeterminate
            color="#6CC8A0"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <ModalSuccess
      :isSuccessModalVisible="isSuccessModalVisible"
      image="employee"
      :text="text"
    />
    <ModalWarning
      :warningModal="warningModal"
      @warningModalUpdate="warningModal = warningModalUpdate"
    />
  </div>
</template>

<script>
import GlobalMixin from "../Mixins/GlobalMixin";
import ModalSuccess from "../../components/ModalSuccess";
import ModalWarning from "../../components/ModalWarning";
import axios from "axios";
import enurl from "@/api/environment";
import $ from "jquery";
import SelectEmailLanguageBtn from "../../components/EmailLanguageButton.vue";
import { mapActions, mapState } from "vuex";
//import SalesInformation from "./SalesInformation.vue";
export default {
  components: { ModalSuccess, ModalWarning, SelectEmailLanguageBtn },
  mixins: [GlobalMixin],
  name: "AddEditCompanyModelNew",
  props: {
    title: String,
    isOpen: Boolean,
    CompanyItem: {
      type: Object,
      default: null
    }
  },

  data: () => ({
    startdate: "",
    startdatesale: null,
    frommenu: false,
    frommenusale: false,
    // activeTab: "general",
    companyId: 0,
    companyName: null,
    telephoneNumber: null,
    email: null,
    editEmail: null,
    countryName: null,
    lockstatus: false,
    cityName: null,
    saleName: null,
    sellingPrice: null,
    purchasePeriod: null,
    address: null,
    note: null,
    status: false,
    userName: "",
    userID: 0,
    password: null,
    empID: null,
    abbreviation: null,
    cur_appr: null,
    check1: false,
    companyIndex: null,
    contactName: null,
    numberOfFile: 0,
    activeEmployee: 0,
    packageName: null,
    paymentStatus: null,
    start_date: null,
    reminder_date: null,
    expiry_date: null,
    lock: false,
    courseStatus: false,
    aiAnswerChecking: false,
    subjectiveTest: false,
    emailCheck: false,
    // businessType: "",
    businessTypeID: 0,
    // paymentStatusID: 0,
    businessTypeOther: null,
    isocheck: false,
    emailcheck: false,
    selectedEmailLang: "thai",
    //...........new data bind....
    search: "",
    rulesDate: {
      required: v => v.split("-").length > 2 || ""
    },
    start_menu: false,
    reminder_menu: false,
    expiry_menu: false,
    oldAbbr: "",
    show1: false,
    rules: {
      required: value => !!value || "Required.",
      min: v => v.length >= 8 || "Min 8 characters",
      emailMatch: () => "The email and password you entered don't match"
    },
    clkeye: true,
    editeye: false,
    url: enurl.apiUrl,
    urlv4: enurl.apiUrlV4,
    warningModal: false,
    isSuccessModalVisible: false,
    text: null,
    start_dateCheck: false,
    reminder_dateCheck: false,
    expiry_dateCheck: false,
    dialog: false,
    password2: "******",
    namecheck: false,
    phonecheck: false,
    mailcheck: false,
    countrycheck: false,
    contactnamecheck: false,
    businesscheck: false,
    paymentdatecheck: false,
    otherbusinesscheck: false,
    useridcheck: false,
    passwordcheck: false,
    citycheck: false,
    salenamecheck: false,
    sellingpricecheck: false,
    purchaseperiodcheck: false,
    paymentstatuscheck: false,
    addresscheck: false,
    //businessTypeID: 0,
    abbrevCheck: false,
    checkalphabet: false,
    checkalphabet2: false,
    checknumber: false,
    phonenolength: false,
    echeck1: true,
    echeck2: true,
    activeemployeecheck: false,
    numberoffilesuploadcheck: false,
    packagenamecheck: false,
    packagenameList: [],
    businesstypeList: [],
    paymentstatustypeList: [],
    otheroptions: false,
    activeemployeeList: [],
    numberoffileList: [],
    // R9-3
    lockcheck: false,
    option: "",
    isockeck: ["success"]
  }),
  mounted: function() {
    this.resetTab();
    // if (!this.currentTab) {
    //   this.resetTab(); // Ensure default tab on mount
    // }
    let self = this;
    self.GetPackageDataList();
    self.GetActiveEmployeeList();
    self.GetNumberOfFileList();
    self.GetBusinessTypeList();
    self.GetPaymentStatusType();
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        console.log("✅ Dialog Opened - Resetting to 'general'");
        this.resetTab(); // Reset tab when dialog opens
      }
    },
    oldAbbr: function() {
      let self = this;

      if (
        self.oldAbbr != 0 &&
        self.oldAbbr != 1 &&
        self.oldAbbr != 2 &&
        self.oldAbbr != 3 &&
        self.oldAbbr != 4 &&
        self.oldAbbr != 5 &&
        self.oldAbbr != 6 &&
        self.oldAbbr != 7 &&
        self.oldAbbr != 8 &&
        self.oldAbbr != 9
      ) {
        let tempKey = self.oldAbbr;
        axios
          .post(`${self.url}Company/CheckAbbre?abbre=${tempKey}`)
          .then(function(response) {
            console.log("response.data.status", response.data.status);
            if (response.data.status == 0) {
              self.check1 = true;
            } else {
              self.check1 = false;
            }
          })
          .catch(function(error) {
            alert(error);
          });
      }
    },
    email: function() {
      let self = this;
      self.mailcheck = false;
      self.echeck2 = true;
    },
    companyName: function() {
      this.namecheck = false;
    },
    abbr: function() {
      this.abbrevCheck = false;
    },
    telephoneNumber: function() {
      this.phonecheck = false;
      this.phonenolength = false;
      this.checknumber = false;
    },
    countryName: function() {
      this.countrycheck = false;
    },
    saleName: function() {
      this.salenamecheck = false;
    },
    sellingPrice: function() {
      this.sellingpricecheck = false;
    },
    purchasePeriod: function() {
      this.purchaseperiodcheck = false;
    },
    cityName: function() {
      this.citycheck = false;
    },
    address: function() {
      this.addresscheck = false;
    },
    contactName: function() {
      this.contactnamecheck = false;
    },

    businessTypeID: function() {
      this.businesscheck = false;
    },
    paymentStatus: function() {
      this.paymentstatuscheck = false;
    },
    businessTypeOther: function() {
      this.otherbusinesscheck = false;
    },
    start_date: function() {
      this.start_dateCheck = false;
    },
    startdatesale: function() {
      this.paymentdatecheck = false;
    },
    reminder_date: function() {
      this.reminder_dateCheck = false;
    },
    expiry_date: function() {
      this.expiry_dateCheck = false;
    },
    activeEmployee: function() {
      this.activeemployeecheck = false;
    },
    packageName: function() {
      this.packagenamecheck = false;
    },
    numberOfFile: function() {
      this.numberoffilesuploadcheck = false;
    },
    userName: function() {
      this.useridcheck = false;
    },
    password: function() {
      this.passwordcheck = false;
    },
    password2: function() {
      this.passwordcheck = false;
    },
    comItem(newVal) {
      this.databindFromMain(newVal);
    }
  },
  computed: {
    ...mapState("companymanagement", ["activeTab"]),
    companyActiveTab: {
      get() {
        return this.$store.state.companymanagement.activeTab;
      },
      set(value) {
        //  // this.$store.dispatch('usercoursestatusreport/changeTab', value);
        this.changeTab(value); // ✅ Call Vuex action instead of directly modifying the state
      }
    },
    // companyActiveTab: {
    //   get() {
    //     console.log("✅ Current Tab (get):", this.activeTab);
    //     return this.activeTab; // Use computed getter
    //   },
    //   set(value) {
    //     console.log("✅ Current Tab (set):", value);
    //     this.changeTab(value); // Use Vuex action
    //   },
    // },

    modalTitle: {
      get() {
        return this.title;
      }
    },
    comItem: {
      get() {
        return this.CompanyItem;
      }
    },
    noteValue: {
      get() {
        return this.note;
      },
      set(value) {
        this.$emit("update:note", value);
      }
    },
    showField() {
      return this.businessTypeID === 30; //"อื่นๆ";
    },

    filteredNames() {
      return this.businesstypeList.filter(x =>
        x.thai_Name.toLowerCase().includes(this.search.toLowerCase())
      );
    },
    abbr: {
      get() {
        return this.abbreviation;
      },
      set(v) {
        if (v.match(/^[a-zA-Z0-9.]+$/) && v.length <= 5) {
          this.abbreviation = v;
          this.oldAbbr = v;
        } else {
          this.abbreviation = new String(
            this.abbreviation || null ? this.abbreviation : ""
          );
          if (!v.length || !v) {
            this.abbreviation = "";
            this.oldAbbr = "";
          }
        }
      }
    }
  },
  methods: {
    ...mapActions("companymanagement", ["changeTab", "resetTab"]),
    resetTab() {
      console.log("✅ Resetting tab to 'general'");
      this.$store.dispatch("companymanagement/resetTab");
      // this.changeTab("general");
    },
    StartViewDate() {},
    localeSellingprice() {
      return this.$t("sellingprice");
    },
    localePurchaseperiod() {
      return this.$t("purchaseperiod");
    },

    databindFromMain(item) {
      console.log("item.check1", item.check1);
      console.log("itemsssss", item);
      if (this.modalTitle === "newcomapny") {
        this.empID = item.empID;
        this.userID = item.userID;
        this.userName = item.userName;
        this.password = item.password;
        this.abbreviation = item.abbreviation;
        this.companyIndex = item.companyIndex;
        this.check1 = item.check1;
        this.contactName = item.contactName;
      } else {
        this.companyId = item.companyId;
        this.companyName = item.companyName;
        this.telephoneNumber = item.telephoneNumber;
        this.email = item.email;
        this.editEmail = item.editEmail;
        this.countryName = item.countryName;
        this.lockstatus = item.lockstatus;
        this.cityName = item.cityName;
        this.address = item.address;
        this.note = item.note;
        this.status = item.status;
        this.userName = item.userName;
        this.userID = item.userID;
        this.password = item.password;
        this.empID = item.empID;
        this.abbreviation = item.abbreviation;
        this.cur_appr = item.cur_appr;
        this.check1 = item.check1;
        this.companyIndex = item.companyIndex;
        this.contactName = item.contactName;
        this.numberOfFile = item.numberOfFilesId;
        this.activeEmployee = item.activeEmployee;
        this.packageName = item.packageName;
        (this.paymentStatus = item.paymentId),
          (this.saleName = item.saleName),
          (this.sellingPrice = item.sellingPrice),
          (this.startdatesale = item.startdatesale
            ? new Date(item.startdatesale).toISOString().split("T")[0]
            : null),
          (this.purchasePeriod = item.purchasePeriod);
        this.start_date = item.start_date;
        this.reminder_date = item.reminder_date;
        this.expiry_date = item.expiry_date;
        this.lock = item.lock;
        this.courseStatus = item.courseStatus;
        this.aiAnswerChecking = item.aiAnswerChecking;
        this.subjectiveTest = item.subjectiveTest;
        // this.emailCheck = item.emailCheck;
        this.businessTypeID = item.businessTypeID;
        this.businessTypeOther = item.businessTypeOther;
        this.isocheck = item.isocheck;
        this.emailcheck = item.emailcheck;
        //this.selectedEmailLang = item.selectedEmailLang;
      }
      this.selectedEmailLang = item.selectedEmailLang;
    },
    UpdateEmailLanguage(lang) {
      this.selectedEmailLang = lang;
    },
    UpdateEmailFlag(flag) {
      this.emailcheck = flag;
    },
    changefilter() {
      let result = this.businesstypeList.filter(x =>
        x.thai_Name.toLowerCase().includes(this.search.toLowerCase())
      );
    },

    handleOptionChange(option) {
      this.option = option;
    },
    searchInLists() {},
    startDateDis() {
      this.start_menu = false;
      if (this.reminder_date == "") {
        this.reminder_date = new Date(
          Date.now() - new Date().getTimezoneOffset() * 60000
        )
          .toISOString()
          .substr(0, 10);
      }
      if (this.start_date > this.reminder_date) {
        this.reminder_date = this.start_date;
      }
    },
    endDateDis() {
      if (this.start_date == "") {
        this.start_date = this.reminder_date;
      }
      if (this.reminder_date > this.expiry_date) {
        this.expiry_date = this.reminder_date;
      }
    },
    expiredDateDis() {
      if (this.reminder_date == "") {
        this.reminder_date = this.expiry_date;
      }
    },
    allowedDatesEnd(val) {
      return val >= this.start_date;
    },
    allowedDatesExpiry(val) {
      return val >= this.reminder_date;
    },
    isNumber(e) {
      this.checknumber = false;
      // Allow: backspace, delete, tab, escape, enter and .
      if (
        $.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190, 17, 18, 16]) !== -1 ||
        // Allow: Ctrl+A,Ctrl+C,Ctrl+V, Command+A
        ((e.keyCode == 65 || e.keyCode == 86 || e.keyCode == 67) &&
          (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: home, end, left, right, down, up
        (e.keyCode >= 35 && e.keyCode <= 40)
      ) {
        // let it happen, don't do anything
        return;
      }
      // Ensure that it is a number and stop the keypress
      if (
        (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
        (e.keyCode < 96 || e.keyCode > 105)
      ) {
        this.checknumber = true;
        this.phonecheck = false;
        this.phonenolength = false;
        e.preventDefault();
      }
    },
    checkAlphabet(event) {
      let letterNumber = /^[a-zA-Z0-9.]+$/;
      if (event.key.match(letterNumber)) {
        this.checkalphabet = false;
      } else {
        this.checkalphabet = true;
      }
    },

    close() {
      this.$emit("close");
      this.salenamecheck = false;
      this.sellingpricecheck = false;
      this.checkalphabet2 = false;
      this.namecheck = false;
      this.checkalphabet = false;
      this.abbrevCheck = false;
      this.checkalphabet = false;
      this.checknumber = false;
      this.phonecheck = false;
      this.phonenolength = false;
      this.mailcheck = false;
      this.countrycheck = false;
      this.citycheck = false;
      this.addresscheck = false;
      this.contactnamecheck = false;
      this.businesscheck = false;
      this.otherbusinesscheck = false;
      this.useridcheck = false;
      this.passwordcheck = false;
      this.useridcheck = false;
      this.start_dateCheck = false;
      this.expiry_dateCheck = false;
      this.reminder_dateCheck = false;
      this.packagenamecheck = false;
      this.activeemployeecheck = false;
      this.numberoffilesuploadcheck = false;
      this.emailnoticheck = false;
      this.lockcheck = false;
    },
    validateEmail(email) {
      //////////////Noted(Reopen)//////////////////////////////
      let re = /^(([^<>()[\]\\,;:\s@"]+(\.[^<>()[]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    Add() {
      let self = this;
      if (!self.validation_company_management()) {
        self.warningModal = true;
      }
      self.checknumber = false;

      let txt = self.CheckValidate();
      if (this.check1 === false) {
        if (this.oldAbbr == "" || this.oldAbbr == null) {
          console.log("because of empty block statement");
        } else {
          alert(this.$t("abbre") + " already exist!");
        }
        return;
      }

      if (txt) {
        const langToSend = self.selectedEmailLang || "thai";

        let temp = {
          companyName: self.companyName,
          telNo: self.telephoneNumber,
          email: self.email,
          country: self.countryName,
          city: self.cityName,
          address: self.address,
          note: self.note,
          status: self.status,
          createBy: "Admin",
          createDate: null,
          empID: "0001",
          username: self.userName,
          password: self.password,
          abb: self.oldAbbr,
          companyIndex: self.companyIndex,
          contactName: self.contactName,
          businessType: "",
          businessTypeID: self.businessTypeID,
          businessTypeOther: self.businessTypeOther,
          activeEmpId: self.activeEmployee,
          numberOfFilesId: self.numberOfFile,
          packageName: self.packageName,
          paymentStatus: self.paymentStatus,
          salesName: self.saleName,
          sellingPrice: Number(self.sellingPrice),
          paymentDate: self.startdatesale,
          purchasePeriod: self.purchasePeriod,
          startDate: self.start_date + "T00:00:00Z",
          reminderDate: self.reminder_date + "T00:00:00Z",
          expiryDate: self.expiry_date + "T00:00:00Z",
          lock: self.lock,
          courseStatus: self.courseStatus,
          aiAnswerChecking: self.aiAnswerChecking,
          subjectiveTest: self.subjectiveTest,
          emailCheck: self.emailcheck,
          isoAccess: self.isocheck,
          emailLanguage: langToSend
        };

        console.log("📤 Sending company data:", temp);

        self.dialog = true;
        axios
          .post(`${self.url}Company/AddCompany`, temp)
          .then(function(response) {
            self.text = "Company added successfully.";
            self.isSuccessModalVisible = true;
            if (response.data.status == 0) {
              self.dialog = false;
            }

            console.log("✅ Sent email language:", temp.emailLanguage);

            // ⚠️ clear values AFTER success (not before POST)
            setTimeout(() => {
              self.selectedEmailLang = "thai"; // default reset (optional)
              self.emailcheck = false;
            }, 500);
          })
          .catch(function(error) {
            self.dialog = false;
            alert(error);
          });
      }
    },
    Edit() {
      let self = this;

      if (!self.validation_company_management1()) {
        self.warningModal = true;
      }

      self.checknumber = false;
      let txt = self.CheckValidate1();
      if (this.check1 === false && this.abbreviation != this.cur_appr) {
        if (this.oldAbbr == "" || this.oldAbbr == null) {
          console.log("becasue of empty block statement");
        } else {
          alert(this.$t("abbre") + " already exist!");
        }
      } else {
        if (txt) {
          let temp = {
            companyId: self.companyId,
            companyName: self.companyName,
            telNo: self.telephoneNumber,
            email: self.email,
            country: self.countryName,
            city: self.cityName,
            address: self.address,
            note: self.note,
            status: self.status,
            abb: self.oldAbbr ? self.oldAbbr : self.abbreviation,
            createBy: null,
            updateBy: "Admin",
            userID: self.userID,
            username: self.userName,
            password: self.password2,
            companyIndex: self.companyIndex,
            lockstatus: self.lockstatus,
            contactName: self.contactName,
            numberOfFilesId: self.numberOfFile,
            activeEmpId: self.activeEmployee,
            packageName: self.packageName,
            paymentStatus: self.paymentStatus,
            salesName: self.saleName,
            sellingPrice: Number(self.sellingPrice),
            paymentDate: self.startdatesale
              ? self.startdatesale + "T00:00:00Z"
              : null,
            // paymentDate: self.startdatesale + "T00:00:00Z",
            purchasePeriod: self.purchasePeriod,
            businessTypeID: self.businessTypeID,
            businessTypeOther: self.businessTypeOther,
            startDate: self.start_date + "T00:00:00Z",
            reminderDate: self.reminder_date + "T00:00:00Z",
            expiryDate: self.expiry_date + "T00:00:00Z",
            lock: self.lock,
            courseStatus: self.courseStatus,
            aiAnswerChecking: self.aiAnswerChecking ?? false,
            subjectiveTest: self.subjectiveTest ?? false,
            emailCheck: self.emailcheck,
            isoAccess: self.isocheck,
            emailLanguage: self.selectedEmailLang
          };

          self.dialog = true; //add loading again, cuz adding time too long
          console.log("update comp data.......", temp);
          axios
            .post(`${self.url}Company/UpdateCompany`, temp)
            .then(function(response) {
              self.text = "Company updated successfully.";
              self.isSuccessModalVisible = true;
              if (response.data.status == 0) {
                self.dialog = false;
              }
              self.selectedEmailLang = null;
              self.emailcheck = false;
            })
            .catch(function(error) {
              self.dialog = false;
              alert(error);
            });
        } else {
          alert("something wrong");
        }
      }
    },
    Reset() {
      let self = this;
      self.saleName = "";
      self.sellingPrice = "";
      self.purchasePeriod = "";
      //self.paymentStatus = "";
      self.companyName = "";
      self.telephoneNumber = "";
      self.email = "";
      self.countryName = "";
      self.cityName = "";
      self.address = "";
      self.note = " ";
      self.contactName = "";
      self.businessTypeID = 0;
    },

    CheckValidate() {
      let self = this;
      self.packagenamecheck = true;
      self.activeemployeecheck = true;
      self.numberoffilesuploadcheck = true;
      //   self.salenamecheck = true;
      //     self.sellingpricecheck = true;
      //      self.paymentstatuscheck = true;
      //      self.paymentdatecheck = true;
      //      self.purchaseperiodcheck = true;
      self.namecheck = true;
      self.phonecheck = true;
      self.checknumber = false;
      self.countrycheck = true;
      self.contactnamecheck = true;
      self.businesscheck = true;
      self.otherbusinesscheck = true;
      self.useridcheck = true;
      self.passwordcheck = true;
      self.mailcheck = true;
      self.citycheck = true;
      self.addresscheck = true;
      self.abbrevCheck = true;
      self.start_dateCheck = true;
      self.reminder_dateCheck = true;
      self.expiry_dateCheck = true;

      let retvalue = true;
      let abb = self.oldAbbr ? self.oldAbbr : self.abbreviation;
      if (self.companyName != "" && self.companyName != undefined) {
        self.namecheck = false;
      } else {
        retvalue = false;
      }
      if (abb != "" && abb != undefined) {
        self.abbrevCheck = false;
      } else {
        retvalue = false;
      }
      if (self.telephoneNumber != "" && self.telephoneNumber != undefined) {
        if (self.telephoneNumber.length < 9) {
          self.phonenolength = true;
          retvalue = false;
        }
        self.phonecheck = false;
      } else {
        self.phonenolength = false;
        self.phonecheck = true;
        retvalue = false;
      }
      if (self.email != "" && self.email != undefined) {
        self.mailcheck = false;
        let aa = self.validateEmail(self.email);
        if (!aa) {
          retvalue = false;
          self.mailcheck = true;
        }
      } else {
        retvalue = false;
      }
      if (self.countryName != "" && self.countryName != undefined) {
        self.countrycheck = false;
      } else {
        retvalue = false;
      }
      if (self.contactName != "" && self.contactName != undefined) {
        self.contactnamecheck = false;
      } else {
        retvalue = false;
      }

      if (self.businessTypeID != "" && self.businessTypeID != undefined) {
        self.businesscheck = false;
      } else {
        retvalue = false;
      }
      if (self.option === "อื่นๆ") {
        if (
          self.businessTypeOther != "" &&
          self.businessTypeOther != undefined
        ) {
          self.otheroptions = true;
          self.otherbusinesscheck = true;
          console.log("otheroption", self.otheroptions);
        } else {
          retvalue = false;
        }
      } else {
        self.businessTypeOther = "";
        self.otherbusinesscheck = false;
        self.otheroptions = false;
      }
      if (self.packageName != "" && self.packageName != undefined) {
        self.packagenamecheck = false;
      } else {
        retvalue = false;
      }
      if (self.activeEmployee != "" && self.activeEmployee != undefined) {
        self.activeemployeecheck = false;
      } else {
        retvalue = false;
      }
      if (self.numberOfFile != "" && self.numberOfFile != undefined) {
        self.numberoffilesuploadcheck = false;
      } else {
        retvalue = false;
      }
      //  if (self.saleName !="" && self.saleName != undefined)
      // {
      //   self.salenamecheck =false;
      // } else {
      //   retvalue = false;
      // }
      // if(self.sellingPrice !="" && self.sellingPrice !=undefined)
      // {
      //   self.sellingpricecheck = false;
      // }
      // else {
      //   retvalue = false;
      // }
      // if(self.paymentStatus !="" && self.paymentStatus != undefined)
      // {
      //   self.paymentstatuscheck = false;
      // } else {
      //   retvalue = false;
      // }
      // if(self.startdatesale !="" && self.startdatesale != undefined)
      // {
      //   self.paymentdatecheck = false;
      // }
      // else {
      //   retvalue = false;
      // }
      // if(self.purchasePeriod !="" && self.purchasePeriod != undefined)
      // {
      //   self.purchaseperiodcheck = false;
      // }
      // else {
      //   retvalue = false;
      // }
      if (self.userName != "" && self.userName != undefined) {
        self.useridcheck = false;
      } else {
        retvalue = false;
      }
      if (self.password != "" && self.password != undefined) {
        self.passwordcheck = false;
      } else {
        retvalue = false;
      }
      if (self.cityName != "" && self.cityName != undefined) {
        self.citycheck = false;
      } else {
        retvalue = false;
      }
      if (self.address != "" && self.address != undefined) {
        self.addresscheck = false;
      } else {
        retvalue = false;
      }
      if (self.start_date != "" && self.start_date != undefined) {
        self.start_dateCheck = false;
      } else {
        retvalue = false;
      }
      if (self.reminder_date != "" && self.reminder_date != undefined) {
        self.reminder_dateCheck = false;
      } else {
        retvalue = false;
      }
      if (self.expiry_date != "" && self.expiry_date != undefined) {
        self.expiry_dateCheck = false;
      } else {
        retvalue = false;
      }
      //////////////Noted(Reopen)//////////////////////////////
      console.log("self.check1", self.check1);
      if (self.check1 === true) {
        console.log("becasue of empty block statement");
      } else {
        retvalue = false;
      }
      if (self.cur_appr != self.oldAbbr) {
        if (self.check1 === true) {
          console.log("becasue of empty block statement");
        } else {
          retvalue = false;
        }
      }
      if (self.echeck2 === false) {
        self.echeck1 = false;
        retvalue = false;
      }
      return retvalue;
    },
    CheckValidate1() {
      let self = this;
      //  self.salenamecheck = true;
      //  self.sellingpricecheck = true;
      //    self.paymentstatuscheck = true;
      //    self.paymentdatecheck = true;
      //   self.purchaseperiodcheck = true;

      self.namecheck = true;
      self.phonecheck = true;
      self.checknumber = false;
      self.countrycheck = true;
      self.contactnamecheck = true;
      self.useridcheck = true;
      self.mailcheck = true;
      self.citycheck = true;
      self.addresscheck = true;
      self.abbrevCheck = true;
      self.activeemployeecheck = true;
      self.numberoffilesuploadcheck = true;
      self.packagenamecheck = true;
      self.start_dateCheck = true;
      self.reminder_dateCheck = true;
      self.expiry_dateCheck = true;

      let retvalue = true;
      let abb = self.oldAbbr ? self.oldAbbr : self.abbreviation;
      if (self.companyName != "" && self.companyName != undefined) {
        self.namecheck = false;
      } else {
        retvalue = false;
      }
      if (self.telephoneNumber != "" && self.telephoneNumber != undefined) {
        if (self.telephoneNumber.length < 9) {
          self.phonenolength = true;
          retvalue = false;
        }
        self.phonecheck = false;
      } else {
        self.phonenolength = false;
        self.phonecheck = true;
        retvalue = false;
      }
      if (abb != "" && abb != undefined) {
        self.abbrevCheck = false;
      } else {
        retvalue = false;
      }
      if (self.email != "" && self.email != undefined) {
        self.mailcheck = false;
        let aa = self.validateEmail(self.email);
        if (!aa) {
          retvalue = false;
          self.mailcheck = true;
        }
      } else {
        retvalue = false;
      }
      if (self.countryName != "" && self.countryName != undefined) {
        self.countrycheck = false;
      } else {
        retvalue = false;
      }
      if (self.contactName != "" && self.contactName != undefined) {
        self.contactnamecheck = false;
      } else {
        retvalue = false;
      }
      if (self.start_date != "" && self.start_date != undefined) {
        self.start_dateCheck = false;
      } else {
        retvalue = false;
      }
      if (self.reminder_date != "" && self.reminder_date != undefined) {
        self.reminder_dateCheck = false;
      } else {
        retvalue = false;
      }
      if (self.expiry_date != "" && self.expiry_date != undefined) {
        self.expiry_dateCheck = false;
      } else {
        retvalue = false;
      }
      if (self.cityName != "" && self.cityName != undefined) {
        self.citycheck = false;
      } else {
        retvalue = false;
      }
      if (self.address != "" && self.address != undefined) {
        self.addresscheck = false;
      } else {
        retvalue = false;
      }
      if (self.cur_appr != self.abbreviation) {
        if (self.check1 === true) {
          console.log("becasue of empty block statement");
        } else {
          retvalue = false;
        }
      }
      if (self.userName != "" && self.userName != undefined) {
        self.useridcheck = false;
      } else {
        retvalue = false;
      }
      if (self.activeEmployee != "" && self.activeEmployee != undefined) {
        self.activeemployeecheck = false;
      } else {
        retvalue = false;
      }
      if (self.packageName != "" && self.packageName != undefined) {
        self.packagenamecheck = false;
      } else {
        retvalue = false;
      }
      if (self.numberOfFile != "" && self.numberOfFile != undefined) {
        self.numberoffilesuploadcheck = false;
      } else {
        retvalue = false;
      }
      // if (self.saleName !="" && self.saleName != undefined)
      // {
      //   self.salenamecheck =false;
      // } else {
      //   retvalue = false;
      // }
      // if(self.sellingPrice !="" && self.sellingPrice !=undefined)
      // {
      //   self.sellingpricecheck = false;
      // }
      // else {
      //   retvalue = false;
      // }
      // if(self.paymentStatus !="" && self.paymentStatus != undefined)
      // {
      //   self.paymentstatuscheck = false;
      // } else {
      //   retvalue = false;
      // }
      // if(self.startdatesale !="" && self.startdatesale != undefined)
      // {
      //   self.paymentdatecheck = false;
      // }
      // else {
      //   retvalue = false;
      // }
      // if(self.purchasePeriod !="" && self.purchasePeriod != undefined)
      // {
      //   self.purchaseperiodcheck = false;
      // }
      // else {
      //   retvalue = false;
      // }
      if (self.echeck2 === false) {
        self.echeck1 = false;
        retvalue = false;
      }
      return retvalue;
    },
    GetPackageDataList() {
      let self = this;
      axios
        .get(`${self.urlv4}Package/GetPackageMasterList`)
        .then(function(response) {
          console.log("response.data.data", response.data.data);
          if (response.data.status == 0) {
            self.packagenameList = response.data.data;
          }
        });
    },
    GetPaymentStatusType() {
      let self = this;
      axios
        .get(`${self.url}PaymentStatusMaster/GetPaymentStatusMasterList`)
        .then(function(response) {
          if (response.data.status == 0) {
            console.log("response.data.data2", response.data.data);
            self.paymentstatustypeList = response.data.data;
          }
        });
      console.log("hello payment status", self.paymentstatustypeList);
    },
    GetBusinessTypeList() {
      let self = this;
      axios.get(`${self.url}Company/GetBusinessType`).then(function(response) {
        if (response.data.status == 0) {
          console.log("hello business type", response.data.data);
          self.businesstypeList = response.data.data;
        }
      });
    },
    GetActiveEmployeeList() {
      let self = this;
      axios
        .get(`${self.urlv4}Package/GetActiveEmpMasterList`)
        .then(function(response) {
          if (response.data.status == 0) {
            self.activeemployeeList = response.data.data;
          }
        });
    },
    GetNumberOfFileList() {
      let self = this;
      axios
        .get(`${self.urlv4}Package/GetNumberOfFilesMasterList`)
        .then(function(response) {
          if (response.data.status == 0) {
            self.numberoffileList = response.data.data;
          }
        });
    },
    localeCompanyName() {
      return this.$t("companyname");
    },
    localeAbbreviation() {
      return this.$t("abbre");
    },
    localeTelephone() {
      return this.$t("telephoneno");
    },
    localeEmail() {
      return this.$t("email");
    },
    localeCountry() {
      return this.$t("country");
    },
    localeCity() {
      return this.$t("city");
    },
    localeSalename() {
      return this.$t("salename");
    },
    localeAddress() {
      return this.$t("address");
    },
    localeNote() {
      return this.$t("note");
    },
    localeStatus() {
      return this.$t("status");
    },
    localeContactName() {
      return this.$t("contactname");
    },
    otheroptionstype() {
      return this.$t("enterbusiness");
    }
  }
};
</script>

<style scoped>
.modal {
  display: block;
  position: fixed;
  z-index: 10;
  left: 0;
  top: 0;
  overflow-y: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background-color: #fefefe;
  margin: 5% auto;
  padding: 30px 40px 15px 40px;
  border: 1px solid #888;
  width: 55%;
  border-radius: 25px;
}
@media only screen and (max-width: 600px) {
  .modal-content {
    width: 90%;
    padding: 30px 20px 15px 20px;
  }
}
.modal-content .close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}
.modal-content .close:hover,
.modal-content .close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.form-group label {
  color: #43425d;
}
.form-group input,
.input-group input {
  /* color: rgba(77, 79, 92, 0.4);  */
  border: 1px solid #e8e9ec;
}
.form-group textarea,
.input-group textarea {
  /*  color: rgba(77, 79, 92, 0.4); */
  border: 1px solid #e8e9ec;
}

.review-box {
  position: relative;
  margin-left: 25px;
  margin-right: 15px;
  padding: 30px 40px;
  border: 1px solid #ecebee;
  font-size: 4rem;
  border-radius: 4px;
}
.review-box i {
  color: rgba(67, 66, 93, 0.2);
}
.review-box .close {
  position: absolute;
  top: -10px;
  right: -10px;
  float: right;
}
.review-box .close i {
  font-size: 28px;
  color: #eb2127;
}
.review-box .close:hover i {
  color: #eb2127;
}

.modal-footer button {
  outline: none;
}
select {
  border: 1px solid #e8e9ec;
  width: 100%;
  height: 40px;
  border-radius: 5px;
  padding-left: 10px;
}

@media only screen and (max-width: 414px) {
  .mobile-password {
    margin-left: -7px !important;
  }
}

.v-input--switch--inset .v-input--selection-controls__input,
.v-input--switch--inset .v-input--switch__track {
  width: 70px !important;
}
@media only screen and (max-width: 375px) {
  .mobile-password {
    margin-left: 0 !important;
  }
}

@media screen and (min-width: 1100px) and (max-width: 1800px) {
  .companyS {
    margin-left: 20px !important ;
  }
}
@media screen and (min-width: 960px) and (max-width: 1100px) {
  .companyS {
    margin-left: 30px !important ;
  }
}
</style>
<style>
.modal {
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
}
.modal::-webkit-scrollbar {
  display: none; /* Safari and Chrome */
}
.v-input--selection-controls.v-input .v-label {
  margin-top: 10px !important;
}
.v-input--switch--inset .v-input--selection-controls__input {
  width: 70px !important;
}
.v-input--switch--inset .v-input--selection-controls__input,
.v-input--switch--inset .v-input--switch__track {
  width: 70px !important;
  height: 31px !important;
}
.v-application--is-ltr .v-input--switch .v-input--selection-controls__ripple {
  left: -12px !important;
}
.v-input--switch .v-input--selection-controls__ripple {
  top: calc(50% - 23px) !important;
}
.v-input--switch__thumb {
  height: 23px !important;
  width: 23px !important;
}

.onoffbtn.v-input--is-label-active
  .v-input__control
  .v-input__slot
  .v-input--selection-controls__input
  .v-input--selection-controls__ripple,
.onoffbtn.v-input--is-label-active
  .v-input__control
  .v-input__slot
  .v-input--selection-controls__input
  .v-input--switch__thumb {
  transform: translate(40px) !important;
}
.v-text-field.v-text-field--enclosed .v-text-field__details {
  display: none;
}
</style>
<style scoped>
.tab-item {
  text-align: center;
  padding: 10px;
  background-color: white;
  border: 1px solid #a6cc39;
  color: #a6cc39;
  font-weight: bold;
  cursor: pointer;
}

/* Selected Tab */
.tab-item.active {
  background-color: #b0ce5e;
  color: white;
}

/* Content Box Styling */
.content-box {
  border-bottom: 2px solid #a6cc39;
  color: #d6c583;
  padding: 8px;
  background: white;
}

.title-text {
  color: #a6cc39;
}
.title-textgeneralandsale {
  margin-top: 18px;
  color: #a6cc39;
}
</style>
